<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <manageBox>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>

    </manageBox>
  </div>
</template>

<script>
import manageBox from "@/components/manageBox";

/**
 * Element UI 图片预览：点遮罩/画布空白处关闭（右上角叉不易发现）。
 * 点在图片、工具栏、翻页/关闭按钮上不关闭。
 */
function isImageViewerBlankTarget(el) {
  if (!el || !el.classList) return false;
  return (
    el.classList.contains("el-image-viewer__mask") ||
    el.classList.contains("el-image-viewer__canvas")
  );
}

function closeImageViewerFromEvent(e) {
  if (!isImageViewerBlankTarget(e.target)) return;
  const wrapper = e.target.closest
    ? e.target.closest(".el-image-viewer__wrapper")
    : null;
  if (!wrapper) return;
  const closeBtn = wrapper.querySelector(".el-image-viewer__close");
  if (closeBtn) closeBtn.click();
}

export default {
  components: {
    manageBox,
  },
  name: "App",
  mounted() {
    document.addEventListener("click", closeImageViewerFromEvent, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", closeImageViewerFromEvent, true);
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
}

.flex {
  display: flex;
  align-items: center;
}

.paytypeColor{
  font-size: 8px;
  color: #999;
}


.Btn {
  width: 70px;
  height: 32px;
  border-radius: 5px;
  color: #ffffff;
  border: 0;
}

#add_item {
  width: 80%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  padding: 10px;
  border: 2px dashed #dedede;
  color: #888;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
}


.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* 宽表格横向滚动，避免分页被挤到视口外 */
.table-scroll-wrap {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
}

/* 列表商品标题过长时换行完整展示，避免省略号截断 */
.el-table td.cell-title-wrap {
  vertical-align: top;
}
.el-table td.cell-title-wrap .cell {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.45;
}

#mainBox,
#box {
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* 图片预览：空白可点关 + 关闭按钮更醒目 */
.el-image-viewer__mask,
.el-image-viewer__canvas {
  cursor: pointer;
}
.el-image-viewer__img {
  cursor: grab;
}
.el-image-viewer__close {
  color: #fff !important;
  font-size: 40px !important;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  top: 24px !important;
  right: 24px !important;
  opacity: 0.95;
}
.el-image-viewer__close:hover {
  background: rgba(0, 0, 0, 0.65);
}

/* 闲鱼品牌黄按钮（#FFE60F） */
.btn-goofish.el-button,
.btn-goofish.el-button--default {
  color: #1f1f1f;
  background-color: #ffe60f;
  border-color: #ffe60f;
}
.btn-goofish.el-button:hover,
.btn-goofish.el-button:focus,
.btn-goofish.el-button--default:hover,
.btn-goofish.el-button--default:focus {
  color: #1f1f1f;
  background-color: #f5d900;
  border-color: #f5d900;
}
.btn-goofish.el-button:active,
.btn-goofish.el-button--default:active {
  color: #1f1f1f;
  background-color: #ebd000;
  border-color: #ebd000;
}
.btn-goofish.el-button.is-disabled,
.btn-goofish.el-button.is-disabled:hover,
.btn-goofish.el-button.is-disabled:focus {
  color: #999;
  background-color: #fff6b8;
  border-color: #fff6b8;
}

.btn-goofish-plain.el-button,
.btn-goofish-plain.el-button--default {
  color: #1f1f1f;
  background-color: #fffbe6;
  border-color: #ffe60f;
}
.btn-goofish-plain.el-button:hover,
.btn-goofish-plain.el-button:focus,
.btn-goofish-plain.el-button--default:hover,
.btn-goofish-plain.el-button--default:focus {
  color: #1f1f1f;
  background-color: #ffe60f;
  border-color: #ffe60f;
}
.btn-goofish-plain.el-button.is-disabled,
.btn-goofish-plain.el-button.is-disabled:hover,
.btn-goofish-plain.el-button.is-disabled:focus {
  color: #bbb;
  background-color: #fffbe6;
  border-color: #fff0a0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue